import {
  CITY_LIST,
  CREATE_MASTER,
  GET_AMENITY,
  GET_CONFIGURATION,
  GET_FOLLOWUP,
  GET_FOLLOWUP_STATUS,
  GET_INSENTIVE_TYPE,
  GET_PROPERTY_TYPE,
  MASTER_ERROR,
  MASTER_LIST,
  PAYMENT_TYPE,
  GET_ETHNICITY
} from "../types";

const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};
const initialStatePropertyType = {
  response: null,
  loading: true,
};
const initialStateConfiguration = {
  response: null,
  loading: true,
};
const initialStateAmenity = {
  response: null,
  loading: true,
};
const initialStateInsentiveType = {
  response: null,
  loading: true,
};
const initialStateFollowUp = {
  response: null,
  loading: true,
};
const initialStateFollowUpStatus = {
  response: null,
  loading: true,
};
const initialPaymentList = {
  response: null,
  loading: true,
};
const initialStateCityList = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};
const initialStateEthnicity = {
  response: null,
  loading: true,
};
export function propertyTypeReducer(state = initialStatePropertyType, action) {
  switch (action.type) {
    case GET_PROPERTY_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function configurationReducer(
  state = initialStateConfiguration,
  action
) {
  switch (action.type) {
    case GET_CONFIGURATION:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function amenityReducer(state = initialStateAmenity, action) {
  switch (action.type) {
    case GET_AMENITY:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function statusReducer(state = initialStateFollowUpStatus, action) {
  switch (action.type) {
    case GET_FOLLOWUP_STATUS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function insentiveTypeReducer(
  state = initialStateInsentiveType,
  action
) {
  switch (action.type) {
    case GET_INSENTIVE_TYPE:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function followUpMasterReducer(state = initialStateFollowUp, action) {
  switch (action.type) {
    case GET_FOLLOWUP:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function masterReducer(state = initialState, action) {
  switch (action.type) {
    case MASTER_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case CREATE_MASTER:
      return {
        ...state,
        loading: false,
        create: true,
        detail: false,
        response: action.payload,
      };

    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
export function getCityListMasterReducer(state = initialStateCityList, action) {
  switch (action.type) {
    case CITY_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      }; 
        case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}

export function paymentTypeReducer(state = initialPaymentList, action) {
  switch (action.type) {
    case PAYMENT_TYPE:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      }; 
        case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}

export function ethnicityReducer(
  state = initialStateEthnicity,
  action
) {
  switch (action.type) {
    case GET_ETHNICITY:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case MASTER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}